// src/pages/projects/AddProjectPage.jsx


import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import ProjectForm from '@/components/projects/ProjectForm';


const AddProjectPage = () => {
  const navigate = useNavigate();


  return (
    <>
      <Helmet>
        <title>Add New Project | Stone Beam</title>
      </Helmet>


      <div className="p-6 max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6 flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/projects')}
            className="hover:bg-slate-100"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div>
            <h1 className="text-3xl font-bold text-navy-steal">Add New Project</h1>
            <p className="text-muted-foreground mt-1">
              Enter project details and attach relevant documents below.
            </p>
          </div>
        </div>


        {/* ✅ Use ProjectForm component - it handles everything including API */}
        <ProjectForm isEdit={false} initialData={null} />
      </div>
    </>
  );
};


export default AddProjectPage;